import { render, staticRenderFns } from "./goodList2.vue?vue&type=template&id=39b6be90&scoped=true"
import script from "./goodList2.vue?vue&type=script&lang=js"
export * from "./goodList2.vue?vue&type=script&lang=js"
import style0 from "./goodList2.vue?vue&type=style&index=0&id=39b6be90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b6be90",
  null
  
)

export default component.exports